import { load51LA } from '~/utils/load51la'

function loadAfterFirstInteraction(load: () => void) {
  let started = false
  let fallbackTimer: number | undefined
  const start = () => {
    if (started) return
    started = true
    if (fallbackTimer) window.clearTimeout(fallbackTimer)
    window.removeEventListener('pointerdown', start)
    window.removeEventListener('keydown', start)
    window.removeEventListener('scroll', start)
    load()
  }
  window.addEventListener('pointerdown', start, { once: true, passive: true })
  window.addEventListener('keydown', start, { once: true })
  window.addEventListener('scroll', start, { once: true, passive: true })
  fallbackTimer = window.setTimeout(start, 10000)
}

export default defineNuxtPlugin(async () => {
  try {
    const response = await $fetch<{ code: number; data?: { '51la'?: Record<string, any>; baidu_tongji?: Record<string, any> } }>('/api/v1/public/plugins')
    if (response?.code !== 0) return
    const analytics = response.data?.['51la']
    // Analytics must not compete with the homepage's critical image, font,
    // and API requests. Start it after a real visit signal, or as a fallback
    // once the page has been stable for a while.
    if (analytics) {
      loadAfterFirstInteraction(() => { void load51LA(analytics) })
    }
    const baidu = response.data?.baidu_tongji
    if (baidu?.enabled === true && baidu.id && !document.querySelector('script[data-baidu-tongji]')) {
      loadAfterFirstInteraction(() => {
        const script = document.createElement('script')
        script.dataset.baiduTongji = '1'
        script.async = true
        script.textContent = `var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?${encodeURIComponent(String(baidu.id))}";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();`
        document.head.appendChild(script)
      })
    }
  } catch (_) {}
})
